<template>
  <ValidationProvider :name="label" v-slot="{ errors }" :rules="rules">
    <v-text-field
      v-model="innerValue"
      v-bind="$attrs"
      v-on="$listeners"
      :error-messages="errors"
      :label="label"
      :min="min"
      :max="max"
      :decimalPoint="decimalPoint"
      :comma="comma"
      :rules="[numRules.number, numRules.max, numRules.min]"
      ref="formRef"
    >
    </v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: [Number, String],
    },
    min: Number,
    max: Number,
    decimalPoint: {
      type: [Number, String],
      default: 0,
    },
    comma: {
      type: Boolean,
      default: false,
    },
    negative: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      innerValue: "",
      errorText: this.$t("common.valid.write_only_number"),
      numRules: {
        number: (v) => {
          v = this.deleteComma(v); //콤마제거 후 비교
          const digitRegex = new RegExp(/\d+/);
          const negativeRegax = new RegExp(/(-{0,1})/);
          const decimalRegax = new RegExp(/(\.?)\d*/);

          let numRule = new RegExp(digitRegex.source);

          if (this.negative) {
            numRule = new RegExp(negativeRegax.source + numRule.source);
            this.errorText = this.$t("common.valid.integer", {
              _field_: this.label,
            });
          }
          if (this.decimalPoint > 0) {
            numRule = new RegExp(numRule.source + decimalRegax.source);
            this.errorText =
              this.decimalPoint +
              this.$t("common.valid.decimal_point_validate", [this.decimalPoint]);
          }
          numRule = new RegExp(`^` + numRule.source + `$`);

          // const numRule = new RegExp(/^(-{0,1})\d*(\.{0,1})\d+$/);
          // numRule = new RegExp(`^`+negativeRegax.source+digitRegex.source+decimalRegax.source+`$`);

          return numRule.test(v) || this.errorText;
        },
        max: (v) => {
          if (this.max != undefined) {
            v = this.deleteComma(v); //콤마제거 후 비교
            return (
              v <= this.max ||
              this.$t("common.valid.max_value", {
                _field_: this.label,
                max: this.max,
              })
            );
          } else return true;
        },
        min: (v) => {
          if (this.min != undefined) {
            v = this.deleteComma(v); //콤마제거 후 비교
            return (
              v >= this.min ||
              this.$t("common.valid.min_value", {
                _field_: this.label,
                min: this.min,
              })
            );
          } else return true;
        },
      },
    };
  },
  methods: {
    addComma(num) {
      if (num.indexOf(".") > 0) {
        // 소수점이 있을 때,
        let parts = num.split(".");
        return (
          parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (parts[1] ? "." + parts[1] : ".")
        );
      } else {
        // 소수점이 없을 때,
        return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    deleteComma(num) {
      num = String(num);
      return num.replace(/,/g, "");
    },
    limitDecimalPoint(num) {
      num = Number(num);
      return num.toFixed(this.decimalPoint);
    },
    isNumber() {
      return new RegExp("/[^0-9.]/g");
    },
    numUnderPoint(num) {
      return String(num).substring(String(num).indexOf(".") + 1);
    },
    setValue(number) {
      // '.' 으로 시작될 때, '0.'으로 변경
      const pointFirst = new RegExp(/^(\.)/);
      if (pointFirst.test(number)) {
        number = "0" + number;
      }

      // '00'으로 시작될 때, '0'으로 변경,
      const twoZeroFirst = new RegExp(/^00/);
      if (twoZeroFirst.test(number)) {
        number = number.replace("00", "0");
      }

      // '0/d'일 경우, '/d'로 변경
      const zeroFirstNum = new RegExp(/^0\d+/);
      if (zeroFirstNum.test(number)) {
        number = number.replace("0", "");
      }

      // 기존 콤마 제거
      number = this.deleteComma(number);

      // MAX
      if (number > this.max) {
        number = this.max;
      }

      // 소수점
      if (this.decimalPoint > 0 && String(number).indexOf(".") != -1) {
        if (this.numUnderPoint(number).length > this.decimalPoint) {
          number = this.limitDecimalPoint(number);
        }
      }

      // COMMA
      if (this.comma) {
        number = String(number);
        number = this.addComma(number);
      }

      return number;
    },
  },
  mounted() {
    if (this.value) {
      this.innerValue = this.setValue(this.value);
    }
  },
  watch: {
    innerValue(newVal) {
      // v-model은 'input' 이벤트를 받음
      this.$emit("input", newVal);
    },
    value(newValue) {
      let number = newValue;

      // number 형태 변환
      number = this.setValue(number);

      const field = this.$refs.formRef;
      field.lazyValue = number;
      this.innerValue = number;
    },
  },
};
</script>

<style lang="scss" scoped></style>
